import axios from 'axios'
import { buildQuery } from '../exports/queryStringBuilder'

export default {
    // optionally filter by uer
    async fetch({ query, page, filters }) {
        const path = `auditlogs?query=${query}&page=${page}&${buildQuery(
            filters
        )}`

        console.log('query path', path)
        return await axios.get(path)
    },
    async types() {
        const path = `auditlogs/audit_types`
        return await axios.get(path)
    },
    async delete(id) {
        return await axios.delete(`auditlogs/${id}`)
    },
}
